import { toastr } from 'react-redux-toastr';
import { defineMessages } from 'react-intl';
import { t } from '../utils/translate';
import {
  isAmbassador,
  isModerator,
  isMjgAdmin,
} from '../utils/user';
import Routes from '../routes';

const translations = defineMessages({
  adminButton: {
    id: 'toastr.chronos.adminButton',
    defaultMessage: 'Admin',
    description: 'bouton Admin à la connexion d un multi-profile',
  },
  ambassadorTitle: {
    id: 'toastr.chronos.ambassadorTitle',
    defaultMessage: 'Ambassadeur',
    description: 'Service de connexion - profile atypique',
  },
  moderatorButton: {
    id: 'toastr.chronos.moderatorButton',
    defaultMessage: 'Moderateur',
    description: 'Service de connexion - profile moderateur',
  },
  ambassadorMessage: {
    id: 'toastr.chronos.ambassadorMessage',
    defaultMessage: 'Connectez-vous en tant que...',
    description: 'Service de connexion - profile atypique',
  },
  mjgAdminTitle: {
    id: 'toastr.chronos.mjgAdminTitle',
    defaultMessage: 'Connectez vous sur l\'interface admin',
    description: 'Service de connexion - profile atypique',
  },
  mjgAdminMessage: {
    id: 'toastr.chronos.mjgAdminMessage',
    defaultMessage: 'Vous n\'avez pas de profil ambassadeur. Merci d\'en créer un depuis l\'interface administrateur',
    description: 'Service de connexion - profile atypique',
  },
  adminInterfaceOpening: {
    id: 'toastr.chronos.adminInterfaceOpening',
    defaultMessage: 'Votre interface administrateur est en train de s\'ouvrir',
    description: 'Service de connexion - profile atypique',
  },
});

const CHRONOS_SIGNIN_FORM_ID = 'signin-chronos';
export const buildChronosSigninForm = ({ password, email }) => {
  const chronosSigninForm = document.createElement('FORM');
  chronosSigninForm.name = 'signin-chronos';
  chronosSigninForm.id = CHRONOS_SIGNIN_FORM_ID;
  chronosSigninForm.method = 'POST';
  chronosSigninForm.action = '/users/sign_in';

  const emailField = document.createElement('INPUT');
  emailField.type = 'HIDDEN';
  emailField.name = 'user[email]';
  emailField.value = email;
  chronosSigninForm.appendChild(emailField);

  const pwField = document.createElement('INPUT');
  pwField.type = 'HIDDEN';
  pwField.name = 'user[password]';
  pwField.value = password;
  chronosSigninForm.appendChild(pwField);

  const srcField = document.createElement('INPUT');
  srcField.type = 'HIDDEN';
  srcField.name = 'mjgapp';
  srcField.value = 'aphrodite';
  chronosSigninForm.appendChild(srcField);

  document.body.appendChild(chronosSigninForm);
};

const submitChronosForm = () => {
  const chronosSigninForm = document.getElementById(CHRONOS_SIGNIN_FORM_ID);
  chronosSigninForm.submit();
  toastr.info(t(translations.adminInterfaceOpening));
};

/*
 * @param { UserModel } user
 */
export const spawnChronosSigninFormToastr = (user, credentials) => {
  const toastrConfirmOptions = {
    onOk: () => window.location = Routes.companyAdminBase,
    okText: t(translations.adminButton),
  };
  let toastrMessage;
  const buttons = [];

  // if user has a profile ambassador
  if (isAmbassador(user)) {
    toastrConfirmOptions.cancelText = t(translations.ambassadorTitle);
    toastrMessage = t(translations.ambassadorMessage);
  // else, ask to create it (eg: RH)
  } else {
    toastrConfirmOptions.disableCancel = true;
    toastrMessage = t(translations.mjgAdminTitle);
    toastr.warning(t(translations.mjgAdminMessage));
  }

  if (isMjgAdmin(user)) {
    buildChronosSigninForm(credentials);
    buttons.push({
      text: 'MJG',
      handler: submitChronosForm,
    });
  }

  if (isModerator(user)) {
    buttons.push({
      text: t(translations.moderatorButton),
      handler: () => window.location = Routes.moderatorDashboard,
    });
  }
  toastrConfirmOptions.buttons = buttons;
  toastr.confirm(toastrMessage, toastrConfirmOptions);
};
